import type { FaireProductEntity } from "../../entity_types/product";

export const p_knz2wtr94a: FaireProductEntity = {
  token: "p_knz2wtr94a",
  type: "product",
  name: "Floral Thank You Card | Modern Card | Abstract Thanks",
  brandToken: "b_839fb698",
  brandName: "Daydream Prints",
  imageUrl:
    "https://cdn.faire.com/fastly/a3a10c3ff36e32e1c34a855f9a598f950472e83bfef0947142227dde43e46490.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/83ee2a936277523ac166e79075f0fb7a0368520bd9c9e70d6d275150da1bdb29.png",
    "https://cdn.faire.com/fastly/f5d23a2e9589bb71df413a5ef072db8c8bb8c96636f82faf6f0e39fd01bd5fec.png",
    "https://cdn.faire.com/fastly/ecf690e5ddcc236669ed88aa4dbd022a029c0a1e2667b99e2fc4e1a3f8ee3e25.png",
    "https://cdn.faire.com/fastly/fb7f001e84b6d4ad2b6ee8fe8ae884f81f235f3dcaa230241a745d4f7039b316.png",
    "https://cdn.faire.com/fastly/0757c07d25a04299a10f53f14832a622502d3da43780adcc26d9ba0289118436.png",
    "https://cdn.faire.com/fastly/980585261ad8f97a94a80ca49f44bd56ee78a7497088d7fdd8d910d8d0875b24.png",
  ],
  priceDollars: 3,
  description:
    'A pretty floral thank you card. Featuring an abstract floral design, this card is made for coastal stores. \n\nOur greeting cards are: \n• A2 size card (4.25" x 5.5") (108mmx139mm)\n• Blank inside\n• High-quality digital print on thick, premium textured card\n• 100% Recycled Envelope\n• Packed in an eco-friendly biodegradable clear sleeve \n• Made locally in Portland, Oregon, USA\n\nOur abstract cards feature matisse inspired natural shapes, along with complementary color palettes. They are little mini pieces of Art waiting to celebrate someone special. Other cards include:\n\nBirthday cards: Funny cards for your best friends\nFemale Cards: Cards for your Girls\nHoliday Cards: Christmas and Thanksgiving cards\nBeach cards: Cards that feature surf and beach designs\nWedding Cards: Cards to celebrate newlyweds\nThinking of You Cards: Sympathy cards, empathy cards to show you care\nHand-Illustrated Cards: Beautifully hand-drawn cards that stand out for their artistic touch',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:31.715Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
